import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import { shallowEqual } from 'app-source/utils/shallowEqual';
import classNames from 'classnames';
import Chip from '@material-ui/core/Chip';
import yellow from '@material-ui/core/colors/yellow';

const styles = () => ({
  header: {
    paddingBottom: [0, '!important'],
  },
  hidden: {
    visibility: 'hidden',
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  overline: {
    letterSpacing: 1,
    opacity: 0.3,
  },
  points: {
    textAlign: 'right',
    '& > div': {
      backgroundColor: yellow[100],
    },
  },
  title: {
    fontWeight: 'bold',
    lineHeight: 1.3,
  },
});

class TriviaResultHeaderComponent extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    isCorrect: PropTypes.bool.isRequired,
    points: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['classes'] },
    });
  }

  render() {
    const { classes, isCorrect, points, title } = this.props;

    return (
      <Fragment>
        <CardHeader
          avatar={
            <div className={classNames(classes.points, { [classes.hidden]: !isCorrect })}>
              <Chip label={`+${points || 10}`} />
            </div>
          }
          subheader={
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
          }
          title={
            <Typography variant="overline" className={classNames(classes.title, classes.overline)}>
              {isCorrect ? 'Correct!' : 'Not Quite'}
            </Typography>
          }
          className={classes.header}
          classes={{
            content: classes.headerContent,
            subheader: classes.subheader,
          }}
        />
      </Fragment>
    );
  }
}

export const TriviaResultHeader = withStyles(styles)(TriviaResultHeaderComponent);
